export class ItemFirebase{
  itemName: string;
  itemImageLink: string;
  itemStyle: string;
  itemSize: string;
  itemPrice:string;
  category:string;
  docID:string;
}
